import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

const RequiredUserResourcesTooltip = ({ requiredResources, children }) => {
  const { t } = useTranslation('core');

  if (!requiredResources) return children;

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="required-user-data-tooltip" className={cx(styles.resourcesTooltip, 'in')}>
          {t(
            'quickstarts.stickyHeader.requiredUserResourcesTooltip.createResources',
            'Create {{requiredResources}} to download a configured sample',
            { requiredResources }
          )}
        </Tooltip>
      }
    >
      <div className={styles.resourcesTooltipWrapper}>{children}</div>
    </OverlayTrigger>
  );
};

RequiredUserResourcesTooltip.propTypes = {
  requiredResources: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]).isRequired,
  children: PropTypes.node.isRequired,
};

export default RequiredUserResourcesTooltip;
